import React, { useState } from 'react';
import { t } from 'i18next';
import TabPanel from '@mui/lab/TabPanel';
import TabMenu from '../util/TabMenu';
import CategoryEqu from '../equipmentComponents/CategoryEqu';
import Locations from '../equipmentComponents/Locations';
import Status from '../equipmentComponents/Status';

export default function EquipmentSettings() {
  const [value, setValue] = useState('category-equipment');

  return (
    <div className="text-[var(--text-color)]">
      <TabMenu
        value={value}
        onChange={(v: string) => setValue(v)}
        tabs={[
          { label: t('CatEqu') || 'Category', value: 'category-equipment' },
          { label: t('Location') || 'Locations', value: 'locations' },
          { label: t('Stat') || 'Status', value: 'status' },
        ]}
      >
        <TabPanel value="category-equipment" sx={{ padding: 0 }}>
          <CategoryEqu />
        </TabPanel>
        <TabPanel value="locations" sx={{ padding: 0 }}>
          <Locations />
        </TabPanel>
        <TabPanel value="status" sx={{ padding: 0 }}>
          <Status />
        </TabPanel>
      </TabMenu>
    </div>
  );
}
